// extracted by mini-css-extract-plugin
export var checkbox = "_8j-0";
export var circle = "_8j-3";
export var horizontalContainer = "_8j-7";
export var sm = "_8j-5";
export var switch0 = "_8j-2";
export var switchDisabled = "_8j-8";
export var switchEnabled = "_8j-1";
export var textSwitchContainer = "_8j-9";
export var textSwitchOption = "_8j-a";
export var textSwitchOptionSelected = "_8j-b";
export var verticalContainer = "_8j-6";
export var xs = "_8j-4";